import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { Skeleton } from 'antd';
import { useRbac } from '../../contexts/RbacContext';

interface AuthenticatedRouteProps {
  children: React.ReactNode;
}

/**
 * Проверяет только аутентификацию (наличие currentUser),
 * без проверки конкретных прав RBAC.
 * Для страниц, доступных любому авторизованному пользователю.
 */
export const AuthenticatedRoute: React.FC<AuthenticatedRouteProps> = ({ children }) => {
  const { isLoading, currentUser } = useRbac();
  const location = useLocation();

  if (isLoading) {
    return (
      <div style={{ padding: '48px' }}>
        <Skeleton active paragraph={{ rows: 4 }} />
      </div>
    );
  }

  if (!currentUser) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  return <>{children}</>;
};
